import { render, staticRenderFns } from "./IndexLaporanUmPd.vue?vue&type=template&id=24114c80&"
import script from "./IndexLaporanUmPd.vue?vue&type=script&lang=js&"
export * from "./IndexLaporanUmPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports